"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.feedbackMessage = exports.online = exports.saveNeededCancel = exports.saveNeededOnSaveError = exports.saveNeededOnSave = exports.showSaveNeeded = exports.saveNeeded = void 0;
const saveNeeded = (state) => state.app.saveNeeded;
exports.saveNeeded = saveNeeded;
const showSaveNeeded = (state) => (0, exports.saveNeeded)(state).showSaveNeeded;
exports.showSaveNeeded = showSaveNeeded;
const saveNeededOnSave = (state) => (0, exports.saveNeeded)(state).onSave;
exports.saveNeededOnSave = saveNeededOnSave;
const saveNeededOnSaveError = (state) => (0, exports.saveNeeded)(state).onSaveError;
exports.saveNeededOnSaveError = saveNeededOnSaveError;
const saveNeededCancel = (state) => (0, exports.saveNeeded)(state).cancel;
exports.saveNeededCancel = saveNeededCancel;
const online = (state) => state.app.online;
exports.online = online;
const feedbackMessage = (state) => state.app.feedbackMessage;
exports.feedbackMessage = feedbackMessage;
